import React, { useState, useContext, useEffect } from "react";

import { LayoutContext } from "App/common/hoc/Layout";

function DeleteBackupPlanPopup(props) {
  const { lMethods } = useContext(LayoutContext);
  const [check, setCheck] = useState(false);

  const toggleCheck = () => {
    setCheck(prevState => !prevState);
  };

  useEffect(() => {
    if (check) lMethods.disablePopupConfirm(false);
    else lMethods.disablePopupConfirm(true);
  }, [check]);

  // if(check) lMethods.disablePopupConfirm(false);
  return (
    <>
      <p>
        Deleting a backup plan is an irreversible operation. It will discontinue
        backup for any associated devices with the selected plan.
      </p>
      <p>Do you wish to proceed?</p>
      <div className="check_wrap">
        <div className="check">
          <input
            type="checkbox"
            className="input_checkbox"
            id="confirm_delete"
            checked={check}
            onChange={() => toggleCheck()}
          />
          <label htmlFor="confirm_delete" />
          <label htmlFor="confirm_delete">
            I understand that deleting is irreversible
          </label>
        </div>
      </div>
    </>
  );
}

export default DeleteBackupPlanPopup;
